import { render } from "./NewCuentaEcp.vue?vue&type=template&id=5bd2c0d8&scoped=true"
import script from "./NewCuentaEcp.vue?vue&type=script&lang=js"
export * from "./NewCuentaEcp.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./NewCuentaEcp.vue?vue&type=style&index=1&id=5bd2c0d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd2c0d8"]])

export default __exports__